import {
  Protocol,
  objToStringSettings,
} from "@orbital/games-frontend-library"
const settings = [
  { name: "stake", minStake: "0.10", maxStake: "100.00" },
  { name: "numberOfBets" },
  { name: "music" },
  { name: "sound" },
  { name: "volume" },
]

export const helperSendSettings = (
  stake: any,
  audio: any,
  autoConfigs: any,
  sendSocketMessage: any,
  stakeFromSettings?: string,
  audioFromSettings?: any,
  autoFromSettings?: any,
) => {
  const sendauto = autoFromSettings ? autoFromSettings : autoConfigs
  const sendstake = stakeFromSettings ? stakeFromSettings : stake
  const sendaudio = audioFromSettings ? audioFromSettings : audio
  // terrible code TODO
  const stringified = objToStringSettings(
    {
      stake: [sendstake],
      minStake: settings[0].minStake,
      maxStake: settings[0].maxStake,
      numberOfBets: sendauto.numberOfBets,
      sound: sendaudio.sound,
      music: sendaudio.music,
      volume: sendaudio.volume,
    },
    settings,
  )
  sendSocketMessage(Protocol.USER_SETTINGS_POST, stringified)
}
